module.exports = __webpack_public_path__ + "img/listen-on-anchor.b844c7eb.png";